// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

//Third Party
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

//Components
import { CPDManagementComponent } from './components/cpdManagement';

import { PracticesComponent } from './components/practices';
import { PracticesEditComponentV2 } from './components/practicesEditV2';
import { SelectPracticeComponent } from './components/selectPractice';
import { PracticesViewComponentV2 } from './components/practicesViewV2';
import { ResourceManagementComponent } from './components/resourceManagement';
import { ResourceComponentLandUseComponent } from './components/resourceComponentLandUse';
import { NarrativesComponent } from './components/narratives'; //Home screen with practice listing to view narratives for
import { NarrativesListComponent } from './components/narrativesList'; //Narratives list for a selected practice from the narratives home screen
import { NarrativeAddComponent } from './components/narrativeAdd';
import { NarrativeReviseComponent } from './components/narrativeRevise';
import { NarrativeEditComponent } from './components/narrativeEdit';
import { AssetTypeManagementComponent } from './components/assetTypeManagement';
import { AssetTypeRowModalComponent } from './components/assetTypeRowModal';
import { AssetTypeAddComponent } from './components/assetTypeAdd';
import { AssetTypeEditComponent } from './components/assetTypeEdit';
import { PurposesViewComponent } from './components/purposesView';
import { PurposesManagementComponent } from './components/purposesManagement';
import { AssetHistoryComponent } from './components/assetHistory';

//Modules
import { SharedModule } from '../shared/shared.module';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
export const PracticesRoutes = [
    { path:'practices', component:PracticesComponent, children:[

        { path:'', redirectTo:'viewV2/1', pathMatch:'full' }, //1==first landing, not from a nav link

        { path:'cpdmanagement', component:CPDManagementComponent },

        { path: 'editV2', component: PracticesEditComponentV2 },
        { path: 'editV2/:practiceId', component: PracticesEditComponentV2 },

        { path:'narratives', component: NarrativesComponent},
        { path:'narrativesList/:practiceId', component: NarrativesListComponent},
        { path:'narrativeAdd/:practiceId', component: NarrativeAddComponent},
        { path:'narrativeRevise/:practiceId/:narrativeId', component: NarrativeReviseComponent },
        { path:'narrativeEdit/:practiceId/:narrativeId', component: NarrativeEditComponent },

        { path:'resource', component: ResourceManagementComponent},
        { path:'componentLandUse/:fy/:componentId', component: ResourceComponentLandUseComponent},
        { path:'selectpractice', component: SelectPracticeComponent},

        { path:'viewV2', component:PracticesViewComponentV2 },
        { path:'viewV2/:from', component:PracticesViewComponentV2 },

        { path: 'assetTypes', component: AssetTypeManagementComponent },
        { path: 'assetTypes/add', component: AssetTypeAddComponent },
        { path: 'assetTypes/edit/:assetTypeId', component: AssetTypeEditComponent },

        { path: 'purposesView/:practiceId/:practiceStateId', component: PurposesViewComponent },
        { path: 'purposes', component: PurposesManagementComponent },

        { path: 'assetHistory/:practiceId', component: AssetHistoryComponent },
    ]}

    //{ path:'purpose/:practiceId', component: PracticePurposeManagmentComponent},
];

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// PracticesModule
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@NgModule({
  imports:[
    NgbModule,
    RouterModule,
    SharedModule
  ],
  declarations:[
    CPDManagementComponent,
    NarrativesComponent,
    NarrativesListComponent,
    NarrativeAddComponent,
    NarrativeReviseComponent,
    NarrativeEditComponent,
    PracticesEditComponentV2,
    PracticesComponent,
    PracticesViewComponentV2,
    ResourceManagementComponent,
    ResourceComponentLandUseComponent,
    SelectPracticeComponent,
    AssetTypeManagementComponent,
    AssetTypeRowModalComponent,
    AssetTypeAddComponent,
    AssetTypeEditComponent,
	PurposesViewComponent,
    PurposesManagementComponent,
    AssetHistoryComponent
  ],
    providers: [],
  exports:[]
})
export class PracticesModule{}

